import homeData from "../../data/home.json"; 
import images from "../../assets/images/Constant";
import { GoArrowUpRight } from "react-icons/go";
import { Link } from "react-router-dom";


export default function  Expertise({showStatsCards=true}){

  const { servicesExpertise, features, statsCards,stats } = homeData;

  return (
    <>
      {/* TOP SECTION */}
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center py-16 md:py-20 px-6">

        {/* LEFT CONTENT */}
        <div>
          <div className="flex gap-2">
             <img src={images[servicesExpertise.icon]} alt="" />
          <p className="text-primary font-medium tracking-wide text-base sm:text-lg md:text-[22px]">
            {servicesExpertise?.subtitle}
          </p>
          
          </div>

          <h2 className="text-2xl md:text-heading font-semibold mt-3 text-dark leading-tight ">
            {servicesExpertise?.title}
          </h2>

          <p className="text-light text-description mt-4 max-w-[500px]">
            {servicesExpertise?.description}
          </p>

          <div className="mt-8 space-y-6">
            {features?.map((item, index) => (
              <div key={index} className="flex gap-4 items-start">
                <img
                  src={images[item.icon]}
                  alt=""
                  className="w-8 h-8 md:w-10 md:h-10"
                />
                <div>
                  <h4 className="font-semibold text-subheading">{item.title}</h4>
                  <p className="text-light text-description ">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <Link to="/about" className="mt-8 flex justify-center items-center gap-2 bg-primary text-white px-6 py-3 rounded">
            Read More
            <GoArrowUpRight />
          </Link>
        </div>

        {/* RIGHT IMAGE */}
        <div className="relative flex justify-center lg:justify-end mt-8 lg:mt-0">
          <img src={images.truck} alt="" className="w-full max-w-[427px] h-auto max-h-[420px] sm:max-h-[520px] lg:h-[628px] lg:max-h-none object-contain pl-0 lg:pl-16" />
          <img
            src={images.worker}
            alt=""
            className="absolute bottom-[-24px] sm:bottom-[-40px] left-0 w-[55%] max-w-[200px] sm:w-[70%] sm:max-w-[380px]"
          />
          <div className="absolute left-2 sm:left-4 md:left-0 bg-white shadow-2xl px-3 py-8 sm:px-4 sm:py-12 rounded-md border-t-4 flex flex-col justify-center items-center border-primary w-36 sm:w-auto sm:min-w-[140px]">

            <div className="bg-primary  md:w-12 md:h-12 flex items-center justify-center rounded mb-2">
              <img src={images.vector} alt="" className="w-5 md:w-6 " />
            </div>

            <h3 className="text-lg md:text-xl font-bold text-center">
              {stats.number}
            </h3>

            <p className="text-light text-sm md:text-body">
              {stats.label}
            </p>

          </div>
        </div>
        
      </div>

      {/* ✅ STATS SECTION (OUTSIDE GRID) */}
      {showStatsCards && ( 
      <div className="max-w-[1200px] mx-auto px-6 pb-16 ">

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

  {statsCards.map((item, index) => (
    <div
      key={index}
      className="flex flex-col items-center border justify-center text-center py-10 px-6 bg-white  rounded-lg"
    >
              {/* ICON */}
              <img
                src={images[item.icon]}
                alt=""
                className="w-10 h-10 mb-3"
              />

              {/* NUMBER */}
              <h3 className="text-xl md:text-2xl font-bold">
                {item.number}
              </h3>

              {/* LABEL */}
              <p className="text-gray-500 text-sm mt-1">
                {item.label}
              </p>
            </div>
          ))}

        </div>

      </div>
      )}
    </>
  );
};